/* NNM add-ons v2 (2 Oct 2026): one compact "Add to your order" strip on the cart page and on product pages.
   It reads the cart (and, on a product page, the product in view) and offers the feed, tool and light that suit it.
   Products and live prices come from the collection "planting-day-essentials", printed as JSON by
   snippets/nnm-addons.liquid: a product leaves the strip by leaving that collection or selling out.
   Only parcel-rated garden goods belong in that collection (garden care, hand tools, gloves, solar lights).
   v2: on the cart page the same strip also holds the same-grower plant suggestions made by assets/nnm-freight.js
   (second tab, "More plants"); on phones the strip sits under the top checkout box; garden goods pages get offers too. */
(function () {
  if (window.__nnmAddonsInit) return; /* re-run by a section refresh: the first instance keeps working */
  window.__nnmAddonsInit = true;

  var H = {
    feedGeneral: 'plant-doctor-roots-shoots-and-leaves-controlled-release-fertiliser',
    feedFruit: 'plant-doctor-flowers-fruits-and-roots-granular-fertiliser',
    feedFruitLiquid: 'plant-doctor-flowers-fruits-and-roots-liquid-potassium-fertiliser',
    feedNative: 'plant-doctor-activ8mate-liquid-fertiliser-and-soil-inoculant',
    feedIndoor: 'plant-doctor-indoor-plant-food-liquid-plant-tonic-500ml',
    seaweed: 'plant-doctor-seaweed-secrets-liquid-seaweed-concentrate',
    wetter: 'plant-doctor-nature-s-soil-wetter-liquid-soil-wetting-agent',
    set: 'aluminium-garden-tool-set-with-gloves',
    wide: 'australian-made-aluminium-garden-trowel-wide',
    narrow: 'australian-made-aluminium-garden-trowel-narrow',
    fork: 'australian-made-aluminium-garden-fork',
    cultivator: 'australian-made-aluminium-garden-cultivator',
    ninja: 'ninja-hpt-gripx-gardening-gloves',
    riggers: 'riggers-gloves-for-gardening-and-landscaping',
    spot: 'solar-garden-spot-light',
    spotKit: 'solar-garden-spot-light-kit-3-lights',
    path: 'comet-solar-path-light-with-motion-sensor-2-pack'
  };
  /* short names for a small card (the full title stays on the product page) */
  var SHORT = {};
  SHORT[H.feedGeneral] = 'Roots, Shoots and Leaves Fertiliser';
  SHORT[H.feedFruit] = 'Flowers, Fruits and Roots Fertiliser';
  SHORT[H.feedFruitLiquid] = 'Flowers, Fruits and Roots Liquid';
  SHORT[H.feedNative] = 'Activ8mate Liquid Fertiliser';
  SHORT[H.feedIndoor] = 'Indoor Plant Food, 500ml';
  SHORT[H.seaweed] = 'Seaweed Secrets Liquid Seaweed';
  SHORT[H.wetter] = "Nature's Soil Wetter";
  SHORT[H.set] = 'Garden Tool Set with Gloves';
  SHORT[H.wide] = 'Wide Garden Trowel';
  SHORT[H.narrow] = 'Narrow Garden Trowel';
  SHORT[H.fork] = 'Garden Fork';
  SHORT[H.cultivator] = 'Garden Cultivator';
  SHORT[H.ninja] = 'Ninja GripX Gardening Gloves';
  SHORT[H.riggers] = 'Riggers Gloves';
  SHORT[H.spot] = 'Solar Garden Spot Light';
  SHORT[H.spotKit] = 'Solar Spot Light Kit, 3 Lights';
  SHORT[H.path] = 'Solar Path Lights, 2 Pack';
  var FEEDS = [H.feedGeneral, H.feedFruit, H.feedFruitLiquid, H.feedNative, H.feedIndoor];
  var TOOLS = [H.set, H.wide, H.narrow, H.fork, H.cultivator];
  var GLOVES = [H.ninja, H.riggers];
  var NEEDS_CHOICE = {}; NEEDS_CHOICE[H.set] = 'Glove size'; NEEDS_CHOICE[H.ninja] = 'Size';
  var MAX = { cart: 6, product: 4 };
  var MOBILE = '(max-width: 989px)'; /* the cart page's own phone breakpoint */

  var DATA = null, ITEMS = {}, WHERE = 'cart', busy = false, lastSig = '', timer = null, shell = null, tab = 'extras';
  var tagCache = {};

  function readData() {
    var el = document.getElementById('nnm-addons-data');
    if (!el) return false;
    try { DATA = JSON.parse(el.textContent); } catch (e) { return false; }
    WHERE = DATA.where === 'product' ? 'product' : 'cart';
    ITEMS = {};
    (DATA.items || []).forEach(function (p) { if (p && p.h) ITEMS[p.h] = p; });
    Object.keys(DATA.cart || {}).forEach(function (h) { tagCache[h] = DATA.cart[h]; });
    if (DATA.product && DATA.product.h) tagCache[DATA.product.h] = { type: DATA.product.type, tags: DATA.product.tags };
    return true;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function isService(title) {
    return /installation|planting service|gift card|egift|e-gift|voucher|custom quote|consultation|plant protection/i.test(title || '');
  }
  function has(tags, list) {
    for (var i = 0; i < list.length; i++) if (tags.indexOf(list[i]) !== -1) return true;
    return false;
  }
  /* pot size of a plant line: 300mm and over, or any litre size, is advanced stock */
  function isBig(variantTitle) {
    var t = (variantTitle || '').toLowerCase();
    var m = t.match(/(\d{2,4})\s*mm/);
    if (m) return parseInt(m[1], 10) >= 300;
    return /\b\d+(\.\d+)?\s*l(itre)?s?\b/.test(t) || /ex ground/.test(t);
  }

  function infoFor(handle) {
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    try {
      var s = sessionStorage.getItem('nnmAo:' + handle);
      if (s) { tagCache[handle] = JSON.parse(s); return Promise.resolve(tagCache[handle]); }
    } catch (e) {}
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var info = p ? { type: p.type || '', tags: p.tags || [] } : { type: '', tags: [] };
        tagCache[handle] = info;
        try { sessionStorage.setItem('nnmAo:' + handle, JSON.stringify(info)); } catch (e) {}
        return info;
      })
      .catch(function () { return { type: '', tags: [] }; });
  }

  /* what the order is made of: lines = [{handle, title, variant, amount, qty}] */
  function profile(lines, infos) {
    var c = { plants: 0, pots: 0, goods: 0, units: 0, native: 0, indoor: 0, edible: 0, hedge: 0, tree: 0, border: 0,
              big: false, bigTrees: 0, tubes: false, inCart: {}, hasFeed: false, hasTool: false, hasGloves: false, hasLight: false };
    lines.forEach(function (l, i) {
      var info = infos[i] || { type: '', tags: [] }, tags = info.tags || [], type = info.type || '';
      c.inCart[l.handle] = 1;
      if (isService(l.title)) return;
      if (type === 'Garden Care' && /fertilis|plant food/i.test(l.title)) c.hasFeed = true;
      if (FEEDS.indexOf(l.handle) !== -1) c.hasFeed = true;
      if (TOOLS.indexOf(l.handle) !== -1) c.hasTool = true;
      if (GLOVES.indexOf(l.handle) !== -1 || l.handle === H.set) c.hasGloves = true;
      if (type === 'Garden Lighting') c.hasLight = true;
      if (type === 'Pots') { c.pots += l.amount; return; }
      if (type !== 'Plants & Trees') { c.goods += l.amount; return; }
      c.plants += l.amount; c.units += l.qty;
      var big = isBig(l.variant);
      if (big) c.big = true;
      if (/^tube/i.test(l.variant || '')) c.tubes = true;
      if (has(tags, ['Native', 'Feature: Australian Native'])) c.native += l.amount;
      if (tags.indexOf('Indoor') !== -1 && tags.indexOf('Outdoor') === -1) c.indoor += l.amount;
      if (has(tags, ['Fruiting', 'Feature: Edible'])) c.edible += l.amount;
      if (has(tags, ['Use: Hedging', 'Hedge', 'Screening', 'Use: Screening & Privacy'])) c.hedge += l.amount;
      if (has(tags, ['Use: Borders & Edging', 'Use: Driveways & Avenues'])) c.border += l.amount;
      if (has(tags, ['Tree', 'Palm'])) { c.tree += l.amount; if (big) c.bigTrees += l.qty; }
    });
    return c;
  }

  function finish(out) {
    var seen = {}, uniq = [];
    out.forEach(function (o) { if (!seen[o[0]]) { seen[o[0]] = 1; uniq.push(o); } });
    return uniq.slice(0, MAX[WHERE] || 4);
  }

  /* the offers for a cart (or for a plant or pot in view), most relevant first: [handle, why] */
  function choose(c) {
    var out = [], share = function (v) { return c.plants > 0 ? v / c.plants : 0; };
    function push(h, why) { if (h && ITEMS[h] && !c.inCart[h]) out.push([h, why]); }
    var indoor = share(c.indoor) >= 0.5;

    if (c.plants > 0) {
      /* a big order (10 or more plants, or $400 and over of plants) gets the tool set and the big bag of slow
         release feed; a small one gets a single trowel and a 1 litre liquid feed, the cheapest way in */
      var bigOrder = c.units >= 10 || c.plants >= 40000;
      var setFirst = !indoor && !c.hasTool && bigOrder;
      if (!c.hasFeed) {
        /* natives first (a feed that lists natives), then fruit, then trees and hedges: a lilly pilly hedge is all three */
        if (indoor) push(H.feedIndoor, 'For your indoor plants');
        else if (share(c.native) >= 0.4) push(H.feedNative, 'Liquid feed, suits natives');
        else if (share(c.edible) >= 0.4) {
          if (!bigOrder && ITEMS[H.feedFruitLiquid]) push(H.feedFruitLiquid, 'Liquid feed for fruit and flowers');
          else push(H.feedFruit, 'Feed for fruit and flowers');
        }
        else if (bigOrder && c.big && share(c.tree) >= 0.5) push(H.feedGeneral, 'Slow release feed for trees');
        else if (bigOrder && share(c.hedge) >= 0.4) push(H.feedGeneral, 'Slow release hedge feed');
        else if (bigOrder) push(H.feedGeneral, 'Slow release plant feed');
        else if (c.big && share(c.tree) >= 0.5) push(H.feedNative, 'Liquid feed for new trees');
        else if (share(c.hedge) >= 0.4) push(H.feedNative, 'Liquid feed for your hedge');
        else push(H.feedNative, 'Liquid feed for new plants');
      }
      if (!c.hasTool) {
        if (indoor) push(H.narrow, 'Australian made, for potting up');
        else if (setFirst) push(H.set, 'Four Australian made tools');
        else push(H.wide, c.tubes ? 'Australian made, for tubestock' : 'Australian made, for planting');
      }
      if (!c.hasLight && !indoor) {
        if (share(c.tree) >= 0.3 && c.big) push(c.bigTrees >= 3 ? H.spotKit : H.spot, c.bigTrees >= 3 ? 'Light up your feature trees' : 'Light up your feature tree');
        else if (share(c.hedge) >= 0.4 || share(c.border) >= 0.4) push(H.path, 'Solar lights for paths');
        else push(H.spot, 'Solar light for the garden');
      }
      if (!indoor) push(H.seaweed, 'Seaweed tonic for planting');
      if (!c.hasGloves && !setFirst) push(c.big ? H.riggers : H.ninja, c.big ? 'Tough gloves for digging' : (indoor ? 'Grip gloves for potting' : 'Grip gloves for planting'));
      if (!indoor) push(H.wetter, 'For dry soil and pots');
      if (!c.hasTool && !indoor && !setFirst) push(H.fork, 'Australian made, loosens soil');
    } else if (c.pots > 0) {
      if (!c.hasFeed) push(H.feedNative, 'Liquid feed for potted plants');
      if (!c.hasTool) push(H.wide, 'Australian made, for filling pots');
      push(H.wetter, 'Wetting agent for pots');
      if (!c.hasGloves) push(H.ninja, 'Grip gloves for potting');
      push(H.seaweed, 'Seaweed tonic for pot plants');
    } else if (c.goods > 0) {
      if (c.hasTool && !c.hasGloves) push(H.ninja, 'Grip gloves for your tools');
      if (c.hasGloves && !c.hasTool) push(H.wide, 'Australian made');
      if (!c.hasFeed) push(H.feedNative, 'Liquid feed for garden plants');
      push(H.seaweed, 'Seaweed tonic for the garden');
      if (!c.hasTool) push(H.wide, 'Australian made');
      if (!c.hasGloves && !c.hasTool) push(H.riggers, 'Tough gloves for garden work');
      if (!c.hasLight) push(H.spot, 'Solar light for the garden');
    }
    return finish(out);
  }

  /* the offers on a garden goods page (a tool, gloves, a light, garden care, garden art, the trellis) */
  function chooseForGoods(p, inCart) {
    var out = [], h = p.h, type = p.type || '';
    function push(x, why) { if (x && x !== h && ITEMS[x] && !inCart[x]) out.push([x, why]); }
    if (type === 'Garden Tools') {
      if (h === H.set) {
        push(H.riggers, 'Tough gloves for digging'); push(H.feedNative, 'Liquid feed for new plants');
        push(H.seaweed, 'Seaweed tonic for planting'); push(H.spot, 'Solar light for the garden');
      } else if (GLOVES.indexOf(h) !== -1) {
        push(H.wide, 'Australian made, for planting'); push(H.set, 'Four Australian made tools');
        push(H.fork, 'Australian made, loosens soil'); push(H.seaweed, 'Seaweed tonic for planting');
      } else {
        push(H.ninja, 'Grip gloves to go with it'); push(H.set, 'All four tools, with gloves');
        push(h === H.fork ? H.wide : H.fork, 'Australian made'); push(H.cultivator, 'Australian made');
        push(H.seaweed, 'Seaweed tonic for planting');
      }
    } else if (type === 'Garden Lighting') {
      push(H.spot, 'Solar spot light'); push(H.path, 'Solar lights for paths'); push(H.spotKit, 'Three spot lights, one panel');
    } else if (type === 'Garden Care') {
      push(H.seaweed, 'Seaweed tonic for the garden'); push(H.wetter, 'For dry soil and pots');
      push(H.ninja, 'Grip gloves for garden work'); push(H.wide, 'Australian made');
    } else {
      push(H.spot, 'Light it up after dark'); push(H.path, 'Solar lights for paths');
      push(H.ninja, 'Grip gloves for garden work'); push(H.feedNative, 'Liquid feed for garden plants');
    }
    return finish(out);
  }

  function cardHTML(h, why) {
    var p = ITEMS[h], vs = p.v.filter(function (v) { return v.a; });
    if (!vs.length) return '';
    var name = SHORT[h] || p.t, url = '/products/' + h;
    var choice = NEEDS_CHOICE[h], first = vs[0];
    var sel = '';
    if (vs.length > 1) {
      sel = '<select class="nnm-ao__opt" aria-label="' + esc(choice || 'Size') + ' for ' + esc(name) + '">';
      if (choice) sel += '<option value="">' + esc(choice) + '</option>';
      vs.forEach(function (v) {
        sel += '<option value="' + v.id + '" data-p="' + v.p + '" data-c="' + (v.c || 0) + '">' + esc(v.t) + '</option>';
      });
      sel += '</select>';
    }
    var was = first.c && first.c > first.p ? ' <s class="nnm-ao__was">' + money(first.c) + '</s>' : '';
    return '<div class="nnm-ao__card" data-h="' + esc(h) + '">'
      + '<a class="nnm-ao__img" href="' + url + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="56" height="56">' : '') + '</a>'
      + '<div class="nnm-ao__body">'
      + '<span class="nnm-ao__why">' + esc(why) + '</span>'
      + '<a class="nnm-ao__name" href="' + url + '">' + esc(name) + '</a>'
      + '<span class="nnm-ao__price">' + money(first.p) + was + '</span>'
      + '</div>'
      + '<div class="nnm-ao__foot">' + sel
      + '<button type="button" class="nnm-ao__add" data-vid="' + (vs.length > 1 && choice ? '' : first.id) + '" aria-label="Add ' + esc(name) + ' to your order">Add</button></div>'
      + '</div>';
  }

  function mount() { return document.querySelector('[data-nnm-addons]'); }

  /* the strip is built once and then only its parts change, because on the cart page its second panel holds a
     node that belongs to assets/nnm-freight.js (the same-grower plant suggestions) */
  function ensureShell() {
    var m = mount();
    if (!m) return null;
    if (!shell) {
      shell = document.createElement('div');
      shell.className = 'nnm-ao';
      shell.setAttribute('role', 'region');
      shell.setAttribute('aria-label', 'Add to your order');
      var arrow = function (dir, label, d) {
        return '<button type="button" class="nnm-ao__arrow" data-dir="' + dir + '" aria-label="' + label + '">'
          + '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="' + d + '" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      };
      shell.innerHTML = '<div class="nnm-ao__head"><p class="nnm-ao__title">Add to your order</p><p class="nnm-ao__sub"></p>'
        + '<div class="nnm-ao__tabs" role="tablist" hidden>'
        + '<button type="button" class="nnm-ao__tab" role="tab" data-tab="extras" aria-selected="true">Feed, tools and lights</button>'
        + '<button type="button" class="nnm-ao__tab" role="tab" data-tab="plants" aria-selected="false">More plants</button></div>'
        + '<span class="nnm-ao__nav">' + arrow(-1, 'Scroll back', 'M15 5l-7 7 7 7') + arrow(1, 'Scroll forward', 'M9 5l7 7-7 7') + '</span></div>'
        + '<div class="nnm-ao__panel" data-panel="extras" role="tabpanel"><div class="nnm-ao__row"></div></div>'
        + '<div class="nnm-ao__panel" data-panel="plants" role="tabpanel" hidden><p class="nnm-ao__note">From the same grower as the plants in your cart.</p>'
        + (WHERE === 'cart' ? '<div data-nnm-sug-host></div>' : '') + '</div>';
    }
    if (shell.parentNode !== m) m.appendChild(shell);
    return shell;
  }

  function rowOf(panel) { return panel.querySelector('.nnm-ao__row') || panel.querySelector('.nnm-sug-row'); }

  /* show what there is: both kinds = two tabs, one kind = that kind with a plain heading, nothing = hidden */
  function sync() {
    var m = mount();
    if (!m || !shell) return;
    var hasExtras = !!shell.querySelector('[data-panel="extras"] .nnm-ao__card');
    var hasPlants = !!shell.querySelector('[data-panel="plants"] .nnm-sug-card');
    if (!hasExtras && !hasPlants) { m.hidden = true; return; }
    var both = hasExtras && hasPlants;
    var active = both ? tab : (hasExtras ? 'extras' : 'plants');
    shell.querySelector('.nnm-ao__tabs').hidden = !both;
    var sub = shell.querySelector('.nnm-ao__sub');
    sub.hidden = both;
    if (!both) {
      var text = 'Goes well with this';
      if (active === 'plants') text = 'More from the same grower';
      else if (WHERE === 'cart') text = 'Picked for what is in your cart';
      else if (DATA.product && DATA.product.type === 'Plants & Trees') text = 'Goes well with this plant';
      if (sub.textContent !== text) sub.textContent = text; /* only on change: this runs inside a mutation observer */
    }
    shell.querySelector('.nnm-ao__note').hidden = !both;
    [].forEach.call(shell.querySelectorAll('.nnm-ao__panel'), function (p) { p.hidden = p.getAttribute('data-panel') !== active; });
    [].forEach.call(shell.querySelectorAll('.nnm-ao__tab'), function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tab') === active ? 'true' : 'false'); });
    m.hidden = false;
    arrows();
  }

  function paint(picks) {
    if (!ensureShell()) return;
    var row = shell.querySelector('[data-panel="extras"] .nnm-ao__row');
    var html = (picks || []).map(function (o) { return cardHTML(o[0], o[1]); }).join('');
    if (row.__nnmH !== html) { row.innerHTML = html; row.__nnmH = html; }
    sync();
  }
  function arrows() {
    if (!shell) return;
    var panel = shell.querySelector('.nnm-ao__panel:not([hidden])'), nav = shell.querySelector('.nnm-ao__nav');
    var row = panel && rowOf(panel);
    if (!row || !nav) return;
    nav.style.visibility = row.scrollWidth > row.clientWidth + 4 ? 'visible' : 'hidden';
  }

  /* phones: the checkout button sits above the cart lines, so the strip goes straight under it */
  var home = null;
  function place() {
    if (WHERE !== 'cart') return;
    var m = mount(); if (!m) return;
    if (!home) { home = document.createComment('nnm-addons home'); m.parentNode.insertBefore(home, m); }
    var top = document.getElementById('cart-summary__secondary');
    var phone = window.matchMedia && window.matchMedia(MOBILE).matches;
    if (phone && top && top.parentNode) {
      if (top.nextSibling !== m) top.parentNode.insertBefore(m, top.nextSibling);
      m.setAttribute('data-nnm-top', '1');
    } else if (home.parentNode) {
      if (home.nextSibling !== m) home.parentNode.insertBefore(m, home.nextSibling);
      m.removeAttribute('data-nnm-top');
    }
    arrows();
  }

  function currentVariantTitle() {
    try {
      var inp = document.querySelector('form[action*="/cart/add"] [name="id"], .js-product-form-main [name="id"]');
      if (inp && DATA.product && DATA.product.variants) return DATA.product.variants[String(inp.value)] || '';
    } catch (e) {}
    return '';
  }

  function refresh() {
    if (!mount() || !DATA) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = (cart.items || []).map(function (it) {
          return { handle: it.handle, title: it.product_title, variant: it.variant_title || '', qty: it.quantity,
                   amount: it.final_line_price != null ? it.final_line_price : it.line_price };
        });
        var onProduct = WHERE === 'product' && DATA.product;
        if (!onProduct && !lines.length) { paint([]); lastSig = ''; return null; }
        var sig = WHERE + '|' + lines.map(function (l) { return l.handle + ':' + l.variant + ':' + l.qty; }).join('|') + '|' + (onProduct ? currentVariantTitle() : '');
        if (sig === lastSig && shell && shell.parentNode) { sync(); return null; }
        var inCart = {};
        lines.forEach(function (l) { inCart[l.handle] = 1; });
        var ptype = onProduct ? (DATA.product.type || '') : '';
        if (onProduct && ptype !== 'Plants & Trees' && ptype !== 'Pots') {
          lastSig = sig;
          paint(chooseForGoods(DATA.product, inCart));
          return null;
        }
        /* on a plant or pot page the product in view decides the offers; the cart only rules out what is already in it */
        var ctxLines = onProduct ? [{ handle: DATA.product.h, title: DATA.product.t, variant: currentVariantTitle(), qty: 1, amount: 100 }] : lines;
        return Promise.all(ctxLines.map(function (l) { return infoFor(l.handle); })).then(function (infos) {
          var c = profile(ctxLines, infos);
          if (onProduct) {
            lines.forEach(function (l) {
              c.inCart[l.handle] = 1;
              if (FEEDS.indexOf(l.handle) !== -1) c.hasFeed = true;
              if (TOOLS.indexOf(l.handle) !== -1) c.hasTool = true;
              if (GLOVES.indexOf(l.handle) !== -1 || l.handle === H.set) c.hasGloves = true;
              if (ITEMS[l.handle] && ITEMS[l.handle].type === 'Garden Lighting') c.hasLight = true;
            });
          }
          lastSig = sig;
          paint(choose(c));
        });
      })
      .catch(function () {});
  }
  function debounced() { clearTimeout(timer); timer = setTimeout(refresh, 250); }

  function refreshTheme() {
    /* cart page: let the theme redraw its own lines and totals; anywhere else just the cart icon */
    var ci = document.querySelector('cart-items');
    if (WHERE === 'cart' && ci && typeof ci.refresh === 'function' && ci.dataset.empty === 'false') {
      try { return Promise.resolve(ci.refresh()); } catch (e) {}
    }
    if (WHERE === 'cart') { window.location.reload(); return Promise.resolve(); }
    return fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var host = document.getElementById('cart-icon-bubble');
        if (!host || !d['cart-icon-bubble']) return;
        var t = document.createElement('template');
        t.innerHTML = d['cart-icon-bubble'];
        var inner = t.content.querySelector('.shopify-section');
        if (inner) host.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('.nnm-ao__opt');
    if (s) {
      var card = s.closest('.nnm-ao__card'), btn = card.querySelector('.nnm-ao__add'), opt = s.options[s.selectedIndex];
      btn.setAttribute('data-vid', s.value || '');
      s.classList.remove('nnm-ao__opt--ask');
      if (s.value) {
        var p = parseInt(opt.getAttribute('data-p'), 10), cmp = parseInt(opt.getAttribute('data-c'), 10) || 0;
        card.querySelector('.nnm-ao__price').innerHTML = money(p) + (cmp > p ? ' <s class="nnm-ao__was">' + money(cmp) + '</s>' : '');
      }
      return;
    }
    if (WHERE === 'product') setTimeout(debounced, 80); /* a new size picked on the product form */
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.nnm-ao__tab');
    if (t) { tab = t.getAttribute('data-tab'); sync(); return; }
    var a = e.target.closest && e.target.closest('.nnm-ao__arrow');
    if (a) {
      var panel = a.closest('.nnm-ao').querySelector('.nnm-ao__panel:not([hidden])'), row = panel && rowOf(panel);
      if (row) row.scrollBy({ left: parseInt(a.getAttribute('data-dir'), 10) * Math.max(220, row.clientWidth * 0.8), behavior: 'smooth' });
      return;
    }
    var b = e.target.closest && e.target.closest('.nnm-ao__add');
    if (!b || busy) return;
    var card = b.closest('.nnm-ao__card'), vid = b.getAttribute('data-vid');
    if (!vid) { /* a size is needed first */
      var sel = card.querySelector('.nnm-ao__opt');
      if (sel) { sel.classList.add('nnm-ao__opt--ask'); sel.focus(); }
      return;
    }
    busy = true; b.disabled = true; b.textContent = 'Adding';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: { _nnm_addon: WHERE } }] }) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        b.textContent = 'Added'; b.classList.add('nnm-ao__add--done');
        return refreshTheme();
      })
      .then(function () { busy = false; lastSig = ''; setTimeout(refresh, 900); })
      .catch(function () {
        busy = false; b.disabled = false; b.textContent = 'Add';
        var m = card.querySelector('.nnm-ao__why'); if (m) m.textContent = 'Sorry, that could not be added';
      });
  });

  /* keep in step with the cart: any change, update or clear the page makes */
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(change|update|clear)/.test(url)) p.then(debounced).catch(function () {});
    return p;
  };
  ['on:line-item:change', 'on:cart:add', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, debounced); });
  window.addEventListener('resize', arrows);
  try { window.matchMedia(MOBILE).addEventListener('change', place); } catch (e) {}

  /* the plant suggestions arrive and leave on their own clock, and a theme section refresh can drop the strip:
     put it back and re-count before the browser paints */
  var syncing = false;
  try {
    new MutationObserver(function () {
      if (syncing) return;
      syncing = true;
      try {
        var m = mount();
        if (m && shell) {
          if (shell.parentNode !== m) m.appendChild(shell);
          sync();
        }
      } finally { syncing = false; }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  function start() {
    if (!readData()) return;
    ensureShell();
    place();
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
